<template>
  <div class="OAList">
    <d2-crud
      ref="OAList"
      :columns="columns"
      :data="tableData"
      :options="options"
      :loading="loading"
      :pagination="pagination"
      @pagination-size-change="handleSizeChange"
      @pagination-current-change="handleCurrentChange"
      @row-click="rowClick"
    />
  </div>
</template>
<script>
import d2Crud from "@d2-projects/d2-crud";

export default {
  name: "OATable",
  components: { d2Crud },
  props: {
    data: {
      default: null
    },
    columns: {
      default: null
    },
    param: {
      default: null
    },
    loading: {
      default: false
    },
    options: {
      default: function() {
        return {
          showHeader: false,
          size: "medium"
        };
      }
    },
    pagination: {
      default: function() {
        return {
          currentPage: 1,
          pageSize: 10,
          total: 4,
          layout: "prev, pager, next"
        };
      }
    }
  },
  data() {
    return {
      tableData: [],
      query: {}
    };
  },
  watch: {
    data: {
      handler: function(val, oldVal) {
        if (val && val.data && val.page) {
          this.tableData = val.data;
          this.pagination.total = val.page.totalRecords;
        }
      },
      deep: true,
      immediate: true
    },
    param: {
      handler: function(val, oldVal) {
        if (val) {
          this.handleSearch(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.handleSearch(this.param);
  },
  methods: {
    async handleSearch(val) {
      this.pagination.currentPage = _.isEqual(this.param, val)
        ? this.pagination.currentPage
        : 1;
      this.param = val;
      this.$emit("search", {
        ...this.param,
        displayLength: this.pagination.pageSize,
        displayStart: this.pagination.currentPage
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.handleSearch(this.param);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.handleSearch(this.param);
    },
    rowClick(row, event, column) {
      this.$emit("rowClick", {
        row,
        event,
        column
      });
    }
  }
};
</script>
<style lang="scss">
.OAList{
  .d2-crud{
    .d2-crud-pagination{
      padding: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OATable/OAList.vue